// ChatGPT Ads storefront bridge v2026-09-13.1
(function () {
  var state = window.ycChatGPTAds = window.ycChatGPTAds || {};
  if (state.eventsBound) return;
  state.eventsBound = true;
  state.bridgeVersion = '2026-09-13.1';
  var sentKeys = Object.create(null);
  var digitsByCurrency = Object.create(null);
  var registrationFlagKey = 'ycChatGPTAdsCreateCustomerSubmitted';

  function normalizeCurrency(currency) {
    var code = String(currency || state.currency || '').trim().toUpperCase();
    return /^[A-Z]{3}$/.test(code) ? code : null;
  }

  function subunits(value) {
    if (typeof value !== 'number' && !(typeof value === 'string' && /^\d+$/.test(value))) return undefined;
    var amount = Number(value);
    return Number.isSafeInteger(amount) && amount >= 0 ? amount : undefined;
  }

  function amountFromShopifySubunits(value, currency) {
    var amount = subunits(value);
    var code = normalizeCurrency(currency);
    if (!code || amount === undefined) return undefined;
    try {
      if (digitsByCurrency[code] === undefined) {
        digitsByCurrency[code] = new Intl.NumberFormat('en', {
          style: 'currency', currency: code
        }).resolvedOptions().maximumFractionDigits;
      }
      // Liquid/Ajax append two zeros for currencies without subunits (e.g. JPY).
      if (digitsByCurrency[code] === 0) amount = Math.round(amount / 100);
      return amount;
    } catch (error) {
      return undefined;
    }
  }

  function withMoney(payload, amount, currency) {
    var code = normalizeCurrency(currency);
    if (code && Number.isSafeInteger(amount) && amount >= 0) {
      payload.amount = amount;
      payload.currency = code;
    }
    return payload;
  }

  function pageUrl() {
    return window.location.href.split('#')[0];
  }

  function measure(eventName, payload, dedupeKey, options) {
    if (!eventName || state.measurementAllowed !== true || typeof window.oaiq !== 'function') return false;
    if (dedupeKey && sentKeys[dedupeKey]) return true;
    try {
      window.oaiq('measure', eventName, payload, options || {});
      if (dedupeKey) sentKeys[dedupeKey] = true;
      return true;
    } catch (error) {
      return false;
    }
  }

  function sendInitialEvents() {
    measure('page_viewed', { type: 'contents' }, 'page_viewed:' + pageUrl());
    if (state.product) {
      var product = state.product;
      var currency = normalizeCurrency(product.currency);
      var amount = amountFromShopifySubunits(product.priceCents, currency);
      var item = withMoney({
        id: String(product.variantId || product.id || ''),
        name: String(product.title || ''), content_type: 'product', quantity: 1
      }, amount, currency);
      measure('contents_viewed', withMoney({
        type: 'contents', contents: [item]
      }, amount, currency), 'contents_viewed:' + product.variantId + ':' + pageUrl());
    }
    if (/\/cart\/?$/.test(window.location.pathname)) {
      measure('custom', { type: 'custom' }, 'cart_viewed:' + pageUrl(), { custom_event_name: 'cart_viewed' });
    }
    if (state.pageType === 'search') {
      measure('custom', { type: 'custom' }, 'search_submitted:' + pageUrl(), { custom_event_name: 'search_submitted' });
    }
  }

  function quantity(value) {
    var result = Number(value);
    return Number.isSafeInteger(result) && result > 0 ? result : undefined;
  }

  function requestItems(body) {
    if (!body) return [];
    if (typeof body === 'string') {
      try { return requestItems(JSON.parse(body)); } catch (error) {
        return requestItems(new URLSearchParams(body));
      }
    }
    if (typeof body.get === 'function' && typeof body.forEach === 'function') {
      var rows = Object.create(null);
      body.forEach(function (value, key) {
        var match = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(key);
        if (match) {
          rows[match[1]] = rows[match[1]] || {};
          rows[match[1]][match[2]] = value;
        }
      });
      var ids = body.getAll ? body.getAll('id') : [body.get('id')];
      if (Object.keys(rows).length) {
        return requestItems({ items: Object.keys(rows).map(function (key) { return rows[key]; }) });
      }
      if (ids.length !== 1 || !ids[0]) return [];
      return requestItems({ id: ids[0], quantity: body.get('quantity') || 1 });
    }
    var items = Array.isArray(body.items) ? body.items : [body];
    return items.filter(function (item) { return item && item.id !== undefined && item.id !== null; })
      .map(function (item) {
        return { id: String(item.id), quantity: quantity(item.quantity === undefined ? 1 : item.quantity) };
      });
  }

  function requestedItems(input, init) {
    try {
      if (init && init.body !== undefined) return Promise.resolve(requestItems(init.body));
      if (input && typeof input.clone === 'function') {
        var copy = input.clone();
        var contentType = copy.headers.get('content-type') || '';
        if (/multipart\/form-data/i.test(contentType)) return copy.formData().then(requestItems).catch(function () { return []; });
        return copy.text().then(requestItems).catch(function () { return []; });
      }
    } catch (error) {}
    return Promise.resolve([]);
  }

  function sendCartAdd(result, requested, currency) {
    var rows = Array.isArray(result && result.items) ? result.items : [result];
    var items = rows.filter(function (item) { return item && (item.variant_id || item.id); })
      .map(function (row) {
        var id = String(row.variant_id || row.id);
        var matches = requested.filter(function (item) { return item.id === id; });
        // Response quantity can be the cart's cumulative quantity. Use the request.
        var added = matches.length === 1 ? matches[0].quantity : undefined;
        var item = { id: id, content_type: 'product' };
        if (row.product_title || row.title) item.name = String(row.product_title || row.title);
        if (added !== undefined) item.quantity = added;
        var lineAmount;
        if (added !== undefined) {
          if (row.final_price !== undefined && row.final_price !== null) {
            var unitAmount = subunits(row.final_price);
            if (unitAmount !== undefined) lineAmount = unitAmount * added;
          } else if (quantity(row.quantity) === added && row.final_line_price !== undefined && row.final_line_price !== null) {
            lineAmount = row.final_line_price;
          }
        }
        return withMoney(item, amountFromShopifySubunits(lineAmount, currency), currency);
      });
    if (!items.length) return;
    var payload = { type: 'contents', contents: items };
    if (items.every(function (item) { return Number.isSafeInteger(item.amount); })) {
      withMoney(payload, items.reduce(function (sum, item) { return sum + item.amount; }, 0), currency);
    }
    measure('items_added', payload);
  }

  function isCartAdd(input, init) {
    try {
      var raw = typeof input === 'string' ? input : input instanceof URL ? input.href : input && input.url;
      var url = new URL(raw || '', window.location.origin);
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      return url.origin === window.location.origin && method === 'POST' && /\/cart\/add(\.js)?$/.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function bindFetchCartEvents() {
    if (typeof window.fetch !== 'function' || window.fetch.ycChatGPTAdsWrapped) return;
    var originalFetch = window.fetch;
    var wrappedFetch = function (input, init) {
      var track = state.measurementAllowed === true && isCartAdd(input, init);
      var epoch = state.consentEpoch;
      var currency = state.currency;
      var requested = track ? requestedItems(input, init) : null;
      var responsePromise = originalFetch.apply(this, arguments);
      // Leave unrelated storefront/payment requests and their Promise identity untouched.
      if (!track) return responsePromise;
      return responsePromise.then(function (response) {
        if (track && response && response.ok && typeof response.clone === 'function') {
          try {
            Promise.all([response.clone().json(), requested]).then(function (results) {
              // Never replay an action taken before consent or across a withdrawal.
              if (state.measurementAllowed === true && state.consentEpoch === epoch) {
                sendCartAdd(results[0], results[1], normalizeCurrency(results[0].currency || currency));
              }
            }).catch(function () {});
          } catch (error) {}
        }
        return response;
      });
    };
    wrappedFetch.ycChatGPTAdsWrapped = true;
    window.fetch = wrappedFetch;
  }

  function bindRegistrationIntent() {
    document.addEventListener('submit', function (event) {
      if (state.measurementAllowed !== true) return;
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var formType = form.querySelector('input[name="form_type"]');
      if (!formType || formType.value !== 'create_customer') return;
      try { window.sessionStorage.setItem(registrationFlagKey, '1'); } catch (error) {}
    }, true);
  }

  function sendRegistrationCompleteIfNeeded() {
    if (!state.customerLoggedIn || state.measurementAllowed !== true) return;
    try {
      if (window.sessionStorage.getItem(registrationFlagKey) !== '1') return;
      if (measure('registration_completed', { type: 'customer_action' }, 'registration_completed')) {
        window.sessionStorage.removeItem(registrationFlagKey);
      }
    } catch (error) {}
  }

  function start() {
    document.addEventListener('yc:chatgpt-ads:ready', function () {
      sendInitialEvents();
      sendRegistrationCompleteIfNeeded();
    });
    sendInitialEvents();
    sendRegistrationCompleteIfNeeded();
    bindRegistrationIntent();
    // cart:update also fires for removals/quantity changes; it is NOT an add signal.
    bindFetchCartEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
